/**
* Dtails+ Toggle read more less
*/

var toggleccessibility = function (event) {
  if (event.getAttribute('aria-expanded') === 'true') {
    event.setAttribute('aria-expanded', false);
  } else {
    event.setAttribute('aria-expanded', true);
  }
};

async function getData(handle) {
  const url = "https://luksusbaby.dk/products/" + handle + "?view=get-pro-meta";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const result = await response.json();
    // console.log(result);
    if(parseInt(result) > 1) {
      var sel_product = document.querySelector(".hr-reco-product-card[data-handle='" + handle + "']");
      sel_product.querySelector(".more-color-badge").classList.remove("hidden");
    }
  } catch (error) {
    console.error(error.message);
  }
}

// Listen for click on the document
document.addEventListener('click', function (event) {

  // Bail if our clicked element doesn't match
  var trigger = event.target.closest('[data-dtails-toggle-read-more-less]');
  if (!trigger) return;

  // Get the target content
  var content = document.querySelector('#' + trigger.getAttribute('aria-controls'));
  if (!content) return;

  // Prevent default link behavior
  event.preventDefault();

  // Toggle Accessbility
  toggleccessibility(trigger);

  // Toggle our content
  content.classList.toggle('dtails-hidden');

  // Toggle trigger read more less text
  trigger.querySelector('[data-dtails-toggle-read-less]').classList.toggle('dtails-hidden')
  trigger.querySelector('[data-dtails-toggle-read-more]').classList.toggle('dtails-hidden')

});

// include all HR recommendations in 1 request to avoid duplicate products
document.addEventListener('DOMContentLoaded', async function() {
  if (window.hrRecommendations && window.hrRecommendations != {}) {
    let sectionIds = Object.keys(window.hrRecommendations);
    let requests = [];
    for (let i = 0; i < sectionIds.length; i++) {
      let sectionId = sectionIds[i];
      requests.push(window.hrRecommendations[sectionId]);
    }

    const url = 'https://core.helloretail.com/serve/recoms';
    //const fieldsArray = eval(window.theme.settings.helloretailPlpFields);
    let params = {
      'websiteUuid': window.theme.settings.helloretailUuid,
      'trackingUserId': window.helloRetailTrackingUserId ? window.helloRetailTrackingUserId : '',
      'requests': requests
    };
    const rawResponse = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });
    const content = await rawResponse.json();
    // console.log("content", content);
    if (content.responses && content.responses.length) {
      for (let i = 0; i < sectionIds.length; i++) {
        const sectionId = sectionIds[i];
        const sectionKey = window.hrRecommendations[sectionId].key;
        // find correct response from responses by key
        const response = content.responses.find((response) => response.key === sectionKey);
        const section = document.querySelector(`#${sectionId}`);
        if (section && response && response.products && response.products.length) {
          const products = response.products;
          let currentDate = new Date();
          let imageSize = 560;
          if (window.innerWidth < 768) {
            imageSize = 370;
          }
          for (let i = 0; i < products.length; i++) {
            const product = products[i];
            let productSke = section.querySelector('.slider__item').cloneNode(true);

            // console.log("product.extraData", product.extraData.handle);

            var productUrl = product.url;
            if (productUrl.indexOf('luksusbaby.no') > -1) {
              productUrl = productUrl.replace('luksusbaby.no', window.location.host);
            } else if (productUrl.indexOf('luksusbaby.dk') > -1) {
              productUrl = productUrl.replace('luksusbaby.dk', window.location.host);
            }

            let imageHtml = `<img src="${modifyImageUrl(product.imgUrl, imageSize)}" alt="${product.title}" loading="lazy" class="img-fit card__main-image">`;
            let secondImage = product.imgUrl;
            if (product.extraData && product.extraData.hoverImage) {
              secondImage = product.extraData.hoverImage;
            }
            imageHtml += `<img src="${modifyImageUrl(secondImage, imageSize)}" alt="${product.title}" loading="lazy" class="img-fit card__hover-image" fetchpriority="low">`;
            productSke.querySelector('.card__media > a').innerHTML = imageHtml;

            productSke.querySelector('.card__media a').setAttribute('href', productUrl);
            productSke.querySelector('.card__title a').innerText = product.title;
            productSke.querySelector('.card__title a').setAttribute('href', productUrl);

            var price = parseFloat(product.extraData.feedPrice)
            var compareAtPrice = parseFloat(product.extraData.feedCompareAtPrice)

            let priceFormatted = formatMoney(price * 100, window.theme.settings.moneyFormat);
            if (product.extraData.isFromPrice == 'true') {
              priceFormatted = window.theme.strings.fromPrice + ' ' + priceFormatted;
            }

            let compareAtPriceFormatted = formatMoney(compareAtPrice * 100, window.theme.settings.moneyFormat);
            productSke.querySelector('.price__current').innerText = priceFormatted;
            if (price < compareAtPrice) {
              productSke.querySelector('.price').classList.add('price--on-sale');
              productSke.querySelector('.price__was').innerText = compareAtPriceFormatted;

              let salePercent = Math.round((compareAtPrice - price) / compareAtPrice * 100);
              if (salePercent > 0 && productSke.querySelector('.badge--on-sale')) {
                productSke.querySelector('.badge--on-sale .badge-text').innerText += ` ${salePercent}%`;
                productSke.querySelector('.badge--on-sale').classList.remove('hidden');
              }
            }

            if (!product.inStock && productSke.querySelector('.badge--sold-out')) {
              productSke.querySelector('.badge--sold-out').classList.remove('hidden');
            }

            // add new badge base on published date
            if (productSke.querySelector('.badge--new')) {
              let publishedDate = product.extraData.publishedAt // "2022-02-04T10:53:00+01:00"
              // check if publishedDate < 30 days ago
              let publishedDateObj = new Date(publishedDate);
              let diffTime = Math.abs(currentDate - publishedDateObj);
              let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              if (diffDays < 30) {
                productSke.querySelector('.badge--new').classList.remove('hidden');
              }
            }

            if (product.extraDataList && product.extraDataList.badges && product.extraDataList.badges.length && productSke.querySelector('.badge--custom')) {
              // productSke.querySelector('.badge--custom .badge-text').innerText = product.extraDataList.badges[0];
              // productSke.querySelector('.badge--custom').classList.remove('hidden');
              let badgeArr = [];
              product.extraDataList.badges.forEach(function (badge) {
                if (badge.indexOf('[') > -1 && badge.indexOf(']') > -1) {
                  // parse array
                  let parsedBadge = JSON.parse(badge);
                  if (parsedBadge.length) {
                    badgeArr = badgeArr.concat(parsedBadge);
                  }
                } else {
                  badgeArr.push(badge);
                }
              });
              // unique badgeArr
              badgeArr = [...new Set(badgeArr)];
              badgeArr.forEach(function (badge) {
                let badgeHtml = `<div class="product-label-wrapper flex badge--new badge--custom">
                    <span class="product-label product-label--custom" data-text="${badge.toLowerCase()}">
                      <span class="badge-text">${badge}</span>
                    </span>
                  </div>`;
                productSke.querySelector('.product-label-container').innerHTML += badgeHtml;
              });
            }

            productSke.querySelector('.card__quick-add .js-quick-add')?.setAttribute('data-product-url', productUrl);
            productSke.querySelector('.card__quick-add .quick-add-view-btn')?.setAttribute('href', productUrl);

            if (product.extraData?.strictStringifiedVariantData) {
              let variants = JSON.parse(product.extraData.strictStringifiedVariantData);

              if (variants && variants.length) {
                // sort variants by variant.title (size). Only sort if the title is digit. otherwise, keep default order
                variants.sort((a, b) => {
                  let keyA = sizeSortKey(a.title, true);
                  let keyB = sizeSortKey(b.title, true);

                  if (keyA.category !== keyB.category) {
                    return keyA.category - keyB.category;
                  } else if (keyA.value !== keyB.value) {
                    return keyA.value > keyB.value ? 1 : -1;
                  }
                  return 0;
                });

                let variantHtml = '';
                let isOnlyClass = variants.length == 1 ? 'is-only' : '';
                for (let i = 0; i < variants.length; i++) {
                  if (variants[i].inventoryQuantity > 0) {
                    let parsedTitle = variants[i].title.replace(/"/g, '&quot;').replace(/'/g, "&#39;");
                    variantHtml += `<span class="product-card__size ${isOnlyClass}" data-title="${parsedTitle}">${variants[i].title}</span>`;
                  }
                }
                productSke.querySelector('.product-card_sizes').innerHTML = `${variantHtml}`;

                if (variants.length == 1 && product.inStock) {
                  let singleVariantId = variants[0].id.split('/').pop();
                  if (singleVariantId) {
                    productSke.querySelector('.js-quick-add').setAttribute('data-variant-id', singleVariantId);
                    productSke.querySelector('.js-quick-add').classList.add('js-quick-add-variant');
                  }
                }
              }
            }

            var pro_handle = product.extraData.handle;
            productSke.classList.add("hr-reco-product-card");
            productSke.setAttribute("data-handle", pro_handle);
            section.querySelector('.slider__grid').appendChild(productSke);
            getData(pro_handle);
          }
          section.querySelector('.slider__grid li:first-child').remove(); // remove skeleton grid item
          section.querySelector('.slider__grid li:first-child').remove(); // also remove 2nd item

          // wrap .carousel-slider-inside with .carousel-slider
          let carouselSliderInside = section.querySelector('.carousel-slider-inside');
          let carouselSlider = document.createElement('carousel-slider');
          carouselSlider.className = 'carousel block';
          carouselSlider.appendChild(carouselSliderInside);
          section.querySelector('hr-product-recommendations').appendChild(carouselSlider);

          // show the section after all elements are loaded
          section.querySelector('hr-product-recommendations').removeAttribute('hidden');
        }
      }
    }
  }

  function modifyImageUrl(imageUrl, width) {
    // Check if the URL is from Shopify's CDN
    if (imageUrl.includes("cdn.shopify.com")) {
      // Construct the new URL with the desired size
      let newUrl = imageUrl.split('?')[0].replace(/(\.[^.]*)$/, `_${width}x${width}$1`) + '?' + imageUrl.split('?')[1];
      return newUrl;
    }
  }

  function sizeSortKey(sizeTitle, noFallback = false) {
    const knownSizes = ["XXXS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL"];
    const cmRegex = /^(\d+)\s?cm$/;

    // Check if the title is in the known sizes
    if (knownSizes.includes(sizeTitle)) {
      return { category: 0, value: knownSizes.indexOf(sizeTitle) };
    }

    // Check if the title is a number (only digits)
    if (/^\d+$/.test(sizeTitle)) {
      return { category: 1, value: parseInt(sizeTitle, 10) };
    }

    // Check if the title is a number followed by "cm"
    const cmMatch = sizeTitle.match(cmRegex);
    if (cmMatch) {
      return { category: 2, value: parseInt(cmMatch[1], 10) };
    }

    // For all other cases, treat as a string
    if (!noFallback) {
      return { category: 3, value: sizeTitle };
    } else {
      return { category: 4, value: 0 };
    }
  }

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }
});

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// sticky add to cart on pdp. Not in used at the moment
// document.addEventListener('DOMContentLoaded', function() {
//   const addToCart = document.querySelector('.product-info__add-to-cart');
//   if (addToCart && addToCart.closest('.product-info__block')) {
//     const addToCartParent = addToCart.closest('.product-info__block');
//     let lastScrollTop = 0;
//     let milestone = 0;
//     let viewportHeight = window.innerHeight;

//     window.addEventListener('scroll', function() {
//       let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
//       if (currentScroll > lastScrollTop) {
//         // if entire content of addToCartParent is visible in viewport
//         if (isElementInViewport(addToCartParent)) {
//           if (milestone == 0) {
//             addToCart.classList.add('sticky');
//             addToCartParent.classList.add('has-sticky-child');
//             milestone = addToCartParent.offsetTop;
//           }
//         }
        
//       } else {
//         // Scrolling up
//         if ((viewportHeight + currentScroll - 60) <= milestone && milestone != 0) {
//           addToCart.classList.remove('sticky');
//           addToCartParent.classList.remove('has-sticky-child');
//           milestone = 0;
//         }
//       }
//       lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling
//     }, false);
    
//     function isElementInViewport(el) {
//       var rect = el.getBoundingClientRect();
//       return (
//         rect.top >= 0 &&
//         rect.bottom <= ((window.innerHeight || document.documentElement.clientHeight) - 40)
//       );
//     }
//   }
// });

